"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIZE_TYPES = void 0;
exports.SIZE_TYPES = {
    small: 'small',
    medium: 'medium'
};
